import { gql } from "@apollo/client";

// Light list for the event picker dropdown — org-scoped, sorted by name.
export const GET_EVENTS_FOR_PICKER = gql`
  query GetEventsForSummaryPicker($where: events_bool_exp) {
    events(where: $where, order_by: { name: asc }) {
      id
      name
      start_date
      end_date
      is_active
    }
  }
`;

// Single round-trip for the event summary view. Aggregate sections accept
// $from / $to so the support page can scope to a single event instance when
// the same event_id is reused across years.
export const GET_EVENT_SUMMARY = gql`
  query GetEventSummaryRanged(
    $id: Int!
    $from: timestamptz!
    $to: timestamptz!
  ) {
    events_by_pk(id: $id) {
      id
      name
      is_active
      currency
      timezone
      start_date
      end_date
      start_time
      end_time
      address_street
      address_street_2
      address_city
      address_state
      address_zipcode
      organization {
        id
        name
      }
      payment_processor_id
      payment_processor_config {
        id
        processor
        processing_rate
        is_rfid
        is_active
      }
      ticketing_payment_processor_id
      ticketing_payment_processor_config {
        id
        processor
        processing_rate
      }
      invoicing_payment_processor_id
      invoicing_payment_processor_config {
        id
        processor
      }
      ticketing_service_fee_per_order
      top_up_service_fee_per_order
      top_up_service_fee_percentage
      web_surcharge_percentage
      cashless_top_up_sales
      open_loop_cashless
      available_tokens
      redeemable_tokens
      locations(order_by: [{ vendor: { name: asc } }, { name: asc }]) {
        id
        name
        is_active
        vendor_id
        vendor {
          id
          name
          is_active
        }
        payment_processor_id
        payment_processor_config {
          id
          processor
          payment_processor
        }
      }
      attendees_aggregate(
        where: { created_at: { _gte: $from, _lt: $to } }
      ) {
        aggregate {
          count
        }
      }
      rfid_assets_aggregate(
        where: { created_at: { _gte: $from, _lt: $to } }
      ) {
        aggregate {
          count
          sum {
            cash_balance
            promo_balance
          }
        }
      }
      rfid_active: rfid_assets_aggregate(
        where: {
          is_active: { _eq: true }
          created_at: { _gte: $from, _lt: $to }
        }
      ) {
        aggregate {
          count
        }
      }
      rfid_qr: rfid_assets_aggregate(
        where: {
          is_qr: { _eq: true }
          created_at: { _gte: $from, _lt: $to }
        }
      ) {
        aggregate {
          count
        }
      }
      rfid_access_only: rfid_assets_aggregate(
        where: {
          is_access_only: { _eq: true }
          created_at: { _gte: $from, _lt: $to }
        }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`;

// Every menu↔location attachment at this event, with both sides' owning
// vendor. The client flags rows where menu.vendor_id ≠ location.vendor_id —
// Hasura can't compare two columns across relationships, and the row count
// per event is small, so the filter lives client-side.
export const GET_EVENT_MENU_VENDOR_MISMATCHES = gql`
  query EventMenuVendorMismatches($id: Int!) {
    location_menu(where: { location: { event_id: { _eq: $id } } }) {
      id
      location {
        id
        name
        is_active
        vendor_id
        vendor {
          id
          name
          is_active
        }
      }
      menu {
        id
        name
        is_active
        vendor_id
        vendor {
          id
          name
          is_active
        }
      }
    }
  }
`;
